import { jsonMember, jsonObject } from 'typedjson';
import { AdminMultimediaThumbVariant } from '../../../admin/enums/admin-multimedia-thumb-variant';

@jsonObject
export class MultimediaThumbResponse {
  @jsonMember(String)
  public readonly variant!: AdminMultimediaThumbVariant;

  @jsonMember(String)
  public readonly url!: string;
}
